import { useTranslation } from "react-i18next";
import { Icon } from "@nexus/ui";

interface WizardSuccessProps {
  vendorName: string;
}

export function WizardSuccess({ vendorName }: WizardSuccessProps) {
  const { t } = useTranslation();

  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 px-6 text-center">
      <div className="relative flex items-center justify-center">
        <span
          aria-hidden
          className="absolute size-20 rounded-full bg-primary/15 animate-ping motion-reduce:hidden"
        />
        <span
          aria-hidden
          className="absolute size-28 rounded-full border border-primary/20 animate-in zoom-in-50 fade-in-0 duration-700 ease-out motion-reduce:animate-none"
        />
        <span className="relative flex size-20 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-[0_8px_24px_-8px] shadow-primary/50 animate-in zoom-in-50 fade-in-0 duration-500 ease-out motion-reduce:animate-none">
          <Icon
            name="check"
            color="inherit"
            className="size-10 animate-in zoom-in-0 duration-500 ease-out [animation-delay:120ms] motion-reduce:animate-none"
          />
        </span>
      </div>

      <div className="flex flex-col gap-2 animate-in fade-in-0 slide-in-from-bottom-2 duration-500 ease-out [animation-delay:200ms] fill-mode-both motion-reduce:animate-none">
        <h2 className="text-lg font-semibold tracking-tight text-foreground">
          {t("marketplace.wizard.success.title", { vendorName })}
        </h2>
        <p className="max-w-[44ch] text-sm leading-relaxed text-muted-foreground">
          {t("marketplace.wizard.success.subtitle")}
        </p>
      </div>
    </div>
  );
}
